import { useStores } from 'mobx/hooks/useStores';

import { ISelectOption } from 'views/Widgets/StyledSelect';

export function useClinicianRoleOptions(): ISelectOption<void>[] {
  const { constantsStore, userStore } = useStores();
  return constantsStore.getRolesForSelect().map((categoryOptions) => {
    categoryOptions.options = categoryOptions.options?.map((option) => {
      const role = constantsStore.getRoleById(option.value!)!;
      const isDisabled =
        // Lower hierarchy level means higher rank... :/
        userStore.currentDoctor?.role.metadata.hierarchyLevel > role.metadata.hierarchyLevel;
      return {
        ...option,
        isDisabled
      };
    });
    return categoryOptions;
  });
}
